export const containsIgnoreCase = (
  text: string,
  searchString: string,
): boolean => text.toLowerCase().includes(searchString.toLowerCase());
